import { render, staticRenderFns } from "./topic-list.vue?vue&type=template&id=8d756fd8&"
import script from "./topic-list.ts?vue&type=script&lang=ts&"
export * from "./topic-list.ts?vue&type=script&lang=ts&"
import style0 from "./topic-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports